import 'style/_colors.scss';

/* eslint-disable no-magic-numbers */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable max-params */

const dateFormatOptions = {
    year:  'numeric',
    month: 'long'
};

/**
 * Active CMDB CIs Cake
 * @type Object
 */

export const getChartCMDBGlobalCake = series => (
    {
        chart: {
            type: 'pie'
        },
        title: {
            text: ''
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    format:  '{point.className}: {point.amount}'
                }
            },
            showInLegend: true
        },
        tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat:  '<span style="color:{point.color}">Class: {point.className}</span>: <b>{point.amount}</b> CIs <br/>'
        },

        series
    }
);

/**
 * CMDB Global Last 13 months chart
 * @type Object
 */

export const getChartCMDBGlobalLast13Months = (series, {formatDate, formatMessage}) => ({
    chart: {
        type: 'spline'
    },
    title: {
        text: null
    },
    xAxis: {
        gridLineColor: '#ddd',
        gridLineWidth: 0,
        type:          'category',
        categories:    series[0].data.map(i => formatDate(i.x, dateFormatOptions))
    },
    yAxis: {
        title: null
    },
    series: series.map(s => ({...s, name: formatMessage({id: `chart.cmdb.globalCMDBLast13Months.label`}), data: s.data.map(i => i.y)}))
});


export const getCMDBBackupCakeChart = (series, {formatMessage}) => ({
    chart: {
        type: 'pie'
    },
    title: {
        text: ''
    },
    plotOptions: {
        series: {
            dataLabels: {
                enabled: true,
                formatter() {
                    return `${formatMessage({id: `chart.cmdb.CMDBBackupCake.${this.key}.label`})}: ${this.percentage.toFixed(1)}%`;
                }
            }
        },
        showInLegend: true
    },
    tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormatter() {
            return `<span style="color:${this.color}">${formatMessage({id: `chart.cmdb.CMDBBackupCake.${this.name}.label`})}</span>: <b>${this.y}</b><br/>`;
        }
    },
    series
});


export const getCMDBBackupLast13mChart = (series, {formatDate, formatMessage}) => ({
    chart: {
        type: 'spline'
    },
    title: {
        text: null
    },
    xAxis: {
        gridLineColor: '#ddd',
        gridLineWidth: 0,
        type:          'category',
        categories:    series[0].data.map(i => formatDate(i.x, dateFormatOptions))
    },
    yAxis: {
        title: null
    },
    series: series.map(s => ({...s, name: formatMessage({id: `chart.cmdb.CMDBBackupCake.${s.name}.label`}), data: s.data.map(i => i.y)}))
});


export const getCMDBMonitoringCakeChart = (series, {formatMessage}) => ({
    chart: {
        type: 'pie'
    },
    title: {
        text: ''
    },
    plotOptions: {
        series: {
            dataLabels: {
                enabled: true,
                formatter() {
                    return `${formatMessage({id: `chart.cmdb.CMDBMonitoringCake.${this.key}.label`})}: ${this.percentage.toFixed(1)}%`;
                }
            }
        },
        showInLegend: true
    },
    tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormatter() {
            return `<span style="color:${this.color}">${formatMessage({id: `chart.cmdb.CMDBMonitoringCake.${this.name}.label`})}</span>: <b>${this.y}</b><br/>`;
        }
    },
    series
});


export const getCMDBMonitoringLast13mChart = (series, {formatDate, formatMessage}) => ({
    chart: {
        type: 'spline'
    },
    title: {
        text: null
    },
    xAxis: {
        gridLineColor: '#ddd',
        gridLineWidth: 0,
        type:          'category',
        categories:    series[0].data.map(i => formatDate(i.x, dateFormatOptions))
    },
    yAxis: {
        title: null
    },
    series: series.map(s => ({...s, name: formatMessage({id: `chart.cmdb.CMDBMonitoringCake.${s.name}.label`}), data: s.data.map(i => i.y)}))
});


export const getCMDBPatchCakeChart = (series, {formatMessage}) => ({
    chart: {
        type: 'pie'
    },
    title: {
        text: ''
    },
    plotOptions: {
        series: {
            dataLabels: {
                enabled: true,
                formatter() {
                    return `${formatMessage({id: `chart.cmdb.CMDBPatchCake.${this.key}.label`})}: ${this.percentage.toFixed(1)}%`;
                }
            }
        },
        showInLegend: true
    },
    tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormatter() {
            return `<span style="color:${this.color}">${formatMessage({id: `chart.cmdb.CMDBPatchCake.${this.name}.label`})}</span>: <b>${this.y}</b><br/>`;
        }
    },
    series
});


export const getCMDBPatchLast13mChart = (series, {formatDate, formatMessage}) => ({
    chart: {
        type: 'spline'
    },
    title: {
        text: null
    },
    xAxis: {
        gridLineColor: '#ddd',
        gridLineWidth: 0,
        type:          'category',
        categories:    series[0].data.map(i => formatDate(i.x, dateFormatOptions))
    },
    yAxis: {
        title: null
    },
    series: series.map(s => ({...s, name: formatMessage({id: `chart.cmdb.CMDBPatchCake.${s.name}.label`}), data: s.data.map(i => i.y)}))
});

/* eslint-enable */




// WEBPACK FOOTER //
// ./src/containers/cmdb/config/charts.js